import React from 'react';

type Props = {
  error: Error;
  resetErrorBoundary: () => void;
};

const ErrorFallback: React.FC<Props> = ({ error, resetErrorBoundary }) => (
 <div className="error-container">
    <h2 className="error-title">Oops! Something went wrong.</h2>
    <p className="error-message">❗ {error.message}</p>
    <button className="error-button" onClick={resetErrorBoundary}>
      Try again
    </button>
  </div>
);

export default ErrorFallback;
